import { Text } from "../text/text";

type AutocompleteOptionProps = {
  prediction?: google.maps.places.AutocompletePrediction;
};

export const AutocompleteOption = ({ prediction }: AutocompleteOptionProps) => {
  if (!prediction) return null;
  let skipNumber = 0;

  return (
    <span data-testid={"autocomplete-option"}>
      {prediction.description.split("").map((item, index) => {
        if (skipNumber > index) return null;

        const match = prediction.matched_substrings.find(
          (substring) => substring.offset === index
        );

        if (match) {
          const { offset, length } = match;
          skipNumber = offset + length;

          return (
            <Text
              tagElement="span"
              styleVariant="heading4"
              colorVariant="primaryText"
              key={`${item}${index}`}
            >
              {prediction.description.slice(offset, length + offset)}
            </Text>
          );
        } else {
          return item;
        }
      })}
    </span>
  );
};
